import { Component, OnInit, TemplateRef } from '@angular/core';
import { Court } from './court';
import { Validators, FormGroup, FormBuilder } from '@angular/forms';
import { BsModalRef, ModalOptions, BsModalService } from 'ngx-bootstrap';
import { CourtService } from './court.service';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { DialogService } from 'ng2-bootstrap-modal';
import { CommondialogComponent } from '../../Shared/commondialog/commondialog.component';
import { LocalService } from '../../local.service';

@Component({
  selector: 'app-court',
  templateUrl: './court.component.html',
  styleUrls: ['./court.component.css']
})
export class CourtComponent implements OnInit {
  sendMenuId: number;
  sendPageName: string = 'Court';
  //action rights
  _menuId: any;
  _actionRights: any;
  submitShow: boolean;
  readOnly: boolean; add: boolean; edit: boolean; delete: boolean;

  courtForm: FormGroup;
  courts: Court[] = [];
  courtsactive: Court[] = [];
  court: Court;
  deleteResult: boolean
  postresult: boolean
  putDResult: boolean
  courtModalRef: BsModalRef;
  operation: string;
  userid: number;
  courtid: number;
  submitted = false;
  active: number;
  unamePattern: string;
  confmsg: string;
  p: number = 1; searchText: string;
  itemsPerPage: number = 10;
  config: ModalOptions = {
    backdrop: 'static',
    keyboard: false,
    animated: true,
    class: 'modal-dialog-centered',
    ignoreBackdropClick: true
  }
  showall: boolean = true;
  showallstatus: boolean = false;

  key: string = 'court'; //set default
  reverse: boolean = false;
  constructor(
    private courtservice: CourtService,
    private modalService: BsModalService,
    private formBuilder: FormBuilder,
    private router: Router,
    private toastr: ToastrService, private dialogService: DialogService,
    private localService: LocalService) {
    //code to get relavent menu id      
    if (this.router.getCurrentNavigation().extras.state != undefined) {     
      localStorage.setItem('Court_menuid', this.router.getCurrentNavigation().extras.state.menuid);
      localStorage.setItem('Court_action', this.router.getCurrentNavigation().extras.state.action);
      this._menuId = this.router.getCurrentNavigation().extras.state.menuid;
      this.sendMenuId = this._menuId;
      this._actionRights = this.router.getCurrentNavigation().extras.state.action;
    }
    else {
      if (this._menuId == undefined)
        this._menuId = localStorage.getItem('Court_menuid');
      this.sendMenuId = this._menuId;
      if (this._actionRights == undefined)
        this._actionRights = localStorage.getItem('Court_action');
    } 
  }

  //get f() { return this.userForm.controls; }
  ngOnInit() {
    this.checkIsMenuMapped();
    this.courtForm = this.formBuilder.group({
      courtid: [''],
      court: ['', [Validators.required]],
      active: [''],
      state: ['', [Validators.required]]
    });
    this.searchText = '';
    this.getAll();
    //for action rights
    this.readOnly = false;
    this.add = false;
    this.edit = false;
    this.delete = false;
    this.submitShow = false;
    this.getActionRightsList();
  }

  sort(key) {
    this.key = key;
    this.reverse = !this.reverse;
  }

  getAll() {
    this.courts = [];
    this.courtsactive = [];
    this.courtservice.Get().subscribe(res => {
      this.courts = res;
      if (this.showallstatus == true) {
        this.courts.forEach(data => {
          if (data.active == 1) {
            this.courtsactive.push(data);
          }
        });
        this.courts = [];
        this.courts = this.courtsactive;
      }
    }, error => { this.toastr.error('Error while getting data'); });

  }

  getactiveinactive(showallp) {
    this.courtsactive = [];
    this.showall = showallp;
    this.showallstatus = showallp;
    if (this.showall == true) {
      this.showall = false;
      this.courts.forEach(data => {
        if (data.active == 1) {
          this.courtsactive.push(data);
        }
      });
      this.courts = [];
      this.courts = this.courtsactive;
    }
    else {
      this.showall = true;
      this.courts = [];
      this.getAll();
    }
  }

  checkIsMenuMapped()
  {
    const arrays = this.localService.getJsonValue("menulist");
    const notauthorized = this.localService.getJsonValue("notauthorizedcourt");
    let data = arrays.find(ob => ob['name'] === 'Court');
    if((data == undefined || data =='') && (notauthorized!=="true"))
    {
      this.localService.setJsonValue("notauthorizedcourt","true");
      this.toastr.error('You are not authorized to access this page.');
      this.router.navigate(["home"]);
    }
    if(notauthorized=="true"){
      this.localService.setJsonValue("notauthorizedcourt",null);
      this.router.navigate(["home"]);      
    }
  }

  //assigning value from menu rights button
  getActionRightsList() {
    var btnToEnable = JSON.parse(this._actionRights);
    if (btnToEnable.length > 0) {
      btnToEnable.forEach(d => {
        if (d != undefined) {
          if (d == 1)
            this.readOnly = true;
          else if (d == 2) {
            this.readOnly = true;
            this.add = true;
            this.submitShow = true;
          }
          else if (d == 3) {
            this.readOnly = true;
            this.edit = true;
            // this.submitShow = true;
          }
          else if (d == 4) {
            this.readOnly = true;
            this.delete = true;
          }
        }
      });
    }
  }

  clearForm() {
    //for action rights
    if (this.add == true)
      this.submitShow = true;
    else
      this.submitShow = false;
    this.courtModalRef.hide();
  }

  get g() { return this.courtForm.controls; }

  Post(court: Court) {
    
    this.submitted = true;
    // stop here if form is invalid
    //if (this.courtForm.invalid) {
    //  console.log(this.g);
    //  console.log(this.courtForm.errors);
    //}
    if ((court.court.trim() == undefined) || (court.court.trim() == '')) {
      this.toastr.error('Court should not be empty');
      return;
    }

    if ((court.state.trim() == undefined) || (court.state.trim() == '')) {
      this.toastr.error('State should not be empty');
      return;
    }
    var msg = null;

    //this.userid = +localStorage.getItem("userid");
    this.userid = +this.localService.getJsonValue("userid");
    court.court = court.court.trim();
    if (this.operation == 'add') {

      court.createdby = this.userid;
      msg = "Record Added Successfully";
      this.courtservice.Post(court).subscribe(res => {
        if (res.status == 200) {
          if (res != undefined) {
            if (res.body != 0) {
              this.courtModalRef.hide();
              this.getAll();
              this.toastr.success('Data added successfully');
            }
            else { this.toastr.warning('Record already exists.'); }
          }
        };
      },
        error => {
          this.toastr.error("Error while doing the operation");
          this.postresult = false
        })
    }
    else if (this.operation = 'update') {
      this.submitShow = true;
      court.modifiedby = this.userid;
      msg = "Record updated successfully";
      this.courtservice.Put(court).subscribe(res => {
        if (res.status == 200) {
          if (res != undefined) {
            ;
            if (res.body != 0) {
              this.courtModalRef.hide();
              this.getAll();
              this.toastr.success('Data updated successfully');
            }
            else { this.toastr.warning('Record already exists.'); }
          }
        };
      },
        error => {
          this.toastr.error("Error while doing the operation");
          this.postresult = false
        })
    }

    //console.log(this.courtForm.value);


  }

  ChangeActive(e) {
    if (e.currentTarget.checked) {
      this.courtForm.value.active = 1;
    } else {
      this.courtForm.value.active = 0
    }
  }

  OpenConfirmTemplate(court, template: TemplateRef<any>) {
    if (court.active == 0) {
      this.confmsg = "activate";
    }
    else
      this.confmsg = "deactivate";
    let showpopup = this.dialogService.addDialog(CommondialogComponent,
      {
        title: 'Please Confirm',
        message: 'Are you sure you want to ' + this.confmsg + ' this record ?',
        hclass: 'modelsuccess',
        oktext: 'Yes',
        canceltext: 'No',
        okshow: true,
        cancelshow: true
      }).subscribe((isConfirmed) => {
        if (isConfirmed) {
          this.court = court;

          this.Delete();

        }
       
      });

  }
  
  Delete() {
    var msg;
    if (this.court.active == 0) {
      this.court.active = 1
      msg = "Record activated successfully"
    }
    else {
      this.court.active = 0;
      msg = "Record deactivated successfully"
    }
    //this.userid = +localStorage.getItem("userid");
    this.userid = +this.localService.getJsonValue("userid");
    this.court.modifiedby = this.userid;
    this.courtservice.Delete(this.court).subscribe(res => {
      this.toastr.success(msg);
      this.getAll();
    },
      error => { this.deleteResult = false })

  }

  hidePopup() {
    this.courtModalRef.hide();
  }

  openCourtModal(template: TemplateRef<any>, type, court?: Court) {
    this.operation = type
    
    if (type == 'update') {
      this.courtForm.controls['courtid'].setValue(court.courtid);
      this.courtForm.controls['court'].setValue(court.court);
      this.courtForm.controls['active'].setValue(court.active);
      this.courtForm.controls['state'].setValue(court.state);
      this.court = court;
    }
    if (type == 'add') {
      this.courtForm.controls['courtid'].setValue(0);
      this.courtForm.controls['court'].setValue('');
      this.courtForm.controls['active'].setValue(1);
      this.courtForm.controls['state'].setValue('');
    }
    this.courtModalRef = this.modalService.show(template, this.config);
    const aa = document.getElementsByClassName('modal-content');
    aa[0].classList.remove("modal-content");

  }
   
}
